export default class PickedProduct {
    constructor(id, title, imageUrl, productUrl) {
        this.id = id
        this.title = title
        this.imageUrl = imageUrl
        this.productUrl = productUrl
    }

    isValid() {
        return (this.id && this.title && this.imageUrl && this.productUrl);
    }
}